export const onDemandVideosCmsHelperText =
  "Settings for On-Demand videos hosted in Vimeo and displayed in Coa's web-app.";
